import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";
import FilterTimeFromTo from "../FilterTimeFromTo";
import moment from "moment";

function FilterPKK({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    so_ct: "",
    vat_tu: null,
    kho: null,
    trang_thai: null,
    timeFrom: null,
    timeTo: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.so_ct) {
      condition.so_ct = filter.so_ct.trim();
    }
    if (filter.vat_tu) {
      condition.details = { $elemMatch: { ma_vt: filter.vat_tu.ma_vt } };
    }
    if (filter.kho) {
      condition.ma_kho = filter.kho.ma_kho;
    }
    if (filter.trang_thai) {
      condition.trang_thai = filter.trang_thai.ma_trang_thai;
    }
    if (filter.timeFrom || filter.timeTo) {
      const startDate = moment(filter.timeFrom).startOf("days");
      const endDate = moment(filter.timeTo).endOf("days");
      if (filter.timeFrom && filter.timeTo) {
        condition.ngay_ct = { $gte: startDate, $lte: endDate };
      } else if (filter.timeFrom) {
        condition.ngay_ct = { $gte: startDate };
      } else if (filter.timeTo) {
        condition.ngay_ct = { $lte: endDate };
      }
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        direction="column"
        label="Số CT"
        placeholder="Tìm theo số chứng từ"
        value={filter.so_ct}
        onSearch={(val) => setFilter({ ...filter, so_ct: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Hàng hóa"
        placeholder="Chọn hàng hóa"
        selectTitle="Chọn hàng hóa"
        placeholderSearch="Tìm theo mã, tên hàng"
        apiCode="dmvt"
        searchFields={["ma_vt", "ten_vt"]}
        defaultCondition={{
          sp_yeu_cau_che_bien: false,
          sp_yeu_cau_pha_che: false,
        }}
        getOptionLabel={(option) => option.ten_vt}
        checkEqual={(value, option) => value?.ma_vt === option?.ma_vt}
        value={filter.vat_tu}
        onChange={(val) => setFilter({ ...filter, vat_tu: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Chi nhánh"
        placeholder="Chọn chi nhánh"
        selectTitle="Chọn chi nhánh"
        placeholderSearch="Tìm theo mã, tên chi nhánh"
        apiCode="dmkho"
        searchFields={["ma_kho", "ten_kho"]}
        getOptionLabel={(option) => option.ten_kho}
        checkEqual={(value, option) => value?.ma_kho === option?.ma_kho}
        value={filter.kho}
        onChange={(val) => setFilter({ ...filter, kho: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Trạng thái"
        placeholder="Chọn trạng thái"
        selectTitle="Chọn trạng thái"
        placeholderSearch="Tìm theo tên trạng thái"
        apiCode="trangthai"
        withIdApp={false}
        defaultCondition={{ ma_ct: "PKK" }}
        searchFields={["ma_trang_thai", "ten_trang_thai"]}
        getOptionLabel={(option) => option.ten_trang_thai}
        checkEqual={(value, option) =>
          value?.ma_trang_thai === option?.ma_trang_thai
        }
        value={filter.trang_thai}
        onChange={(val) => setFilter({ ...filter, trang_thai: val })}
      />
      <FilterTimeFromTo
        label="Ngày CT"
        defaultTimeFrom={filter.timeFrom}
        defaultTimeTo={filter.timeTo}
        onSearch={({ timeFrom, timeTo }) =>
          setFilter({ ...filter, timeFrom, timeTo })
        }
      />
    </WrapperFilter>
  );
}

export default FilterPKK;
